import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { vendor, ready } = useAuth();
  const loc = useLocation();
  if (!ready)
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  if (!vendor) return <Navigate to="/vendor/login" replace state={{ from: loc.pathname }} />;
  return children;
};
